import requestAction from '../../utils/requestAction'

export const fetchClasses = (params: string = "", prefix = '') =>
  requestAction('CLASS_LIST', params)(`${prefix}classes`, 'GET')

export const fetchReferencesClasses = (params: string) => fetchClasses(params, 'references/')
